import React from "react";
import styled from "@mui/material/styles/styled";
import Button from "@mui/material/Button";
import { ReactComponent as CopyIcon } from "../../../assets/copy.svg";
import { ReactComponent as PrintIcon } from "../../../assets/print.svg";

//region [[ Styles ]]
const StyledButton = styled(Button)({
  textTransform: "unset",
  padding: "6px 24px",
  margin: "10px",
  fontSize: "16px",
  alignSelf: "center",
}); //endregion [[ Styles ]]

//region [[ Props ]]
export interface ExportDataButtonsProps {
  handlePrint: () => void;
  copyToClipboard: () => void;
}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
const ExportDataButtons = ({
  handlePrint,
  copyToClipboard,
}: ExportDataButtonsProps) => (
  <>
    <StyledButton
      variant={"contained"}
      color={"primary"}
      startIcon={<PrintIcon />}
      onClick={handlePrint}
    >
      Print
    </StyledButton>
    <StyledButton
      variant={"contained"}
      color={"primary"}
      startIcon={<CopyIcon />}
      onClick={() => copyToClipboard()}
    >
      Copy
    </StyledButton>
  </>
);

export default ExportDataButtons;
